var cov_24kmz047mi = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rate/index.tsx",
      hash = "63435175ed25820bacf6209dd20376bfd4d0ca2e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rate/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 15
        },
        end: {
          line: 10,
          column: 4
        }
      },
      "1": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 104
        }
      },
      "2": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "3": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 13
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 15
          },
          end: {
            line: 7,
            column: 16
          }
        },
        loc: {
          start: {
            line: 7,
            column: 113
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 25
          },
          end: {
            line: 8,
            column: 26
          }
        },
        loc: {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 9,
            column: 104
          }
        },
        line: 9
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 78
          },
          end: {
            line: 7,
            column: 108
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 7,
            column: 106
          },
          end: {
            line: 7,
            column: 108
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 81
          },
          end: {
            line: 9,
            column: 100
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 81
          },
          end: {
            line: 9,
            column: 86
          }
        }, {
          start: {
            line: 9,
            column: 90
          },
          end: {
            line: 9,
            column: 100
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rate/index.tsx";

import React from 'react';
import Component from './Rate';
import inputable from '../Form/inputable';
export default (function (background, front) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_24kmz047mi.b[0][0]++, {});
  cov_24kmz047mi.f[0]++;
  var Rate = (cov_24kmz047mi.s[0]++, inputable(function (props) {
    cov_24kmz047mi.f[1]++;
    cov_24kmz047mi.s[1]++;
    return (
      /*#__PURE__*/
      React.createElement(Component, Object.assign({}, opts, props, {
        background: background,
        front: (cov_24kmz047mi.b[1][0]++, front) || (cov_24kmz047mi.b[1][1]++, background),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 9,
          columnNumber: 5
        }
      }))
    );
  }));
  cov_24kmz047mi.s[2]++;
  Rate.displayName = 'ShineoutRate';
  cov_24kmz047mi.s[3]++;
  return Rate;
});